import { ref, watch } from 'vue'
import { defineStore } from 'pinia'
import type AudioPlayer from '@/misc/Audio'

export const useSharedStore = defineStore('shared', () => {
  const showSidebar = ref(false)

  const toggleSidebar = () => (showSidebar.value = !showSidebar.value)
  const projectOrigin = ref<string>()
  const projectName = ref<string>()

  const STORAGE_KEY = 'nt:projectParams'

  const raw = localStorage.getItem(STORAGE_KEY)
  if (raw) {
    const parsed = JSON.parse(raw)
    if (parsed && typeof parsed === 'object') {
      if (parsed.projectOrigin) projectOrigin.value = parsed.projectOrigin
      if (parsed.projectName) projectName.value = parsed.projectName
    }
  }

  watch([projectOrigin, projectName], ([origin, name]) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ projectOrigin: origin, projectName: name }))
  })

  // Shared audio player state for spectrogram
  const currentAudioPlayer = ref<AudioPlayer | null>(null)
  const audioNormalized = ref(false)

  const setCurrentAudioPlayer = (player: AudioPlayer | null) => {
    currentAudioPlayer.value = player
  }

  const toggleAudioNormalization = () => {
    audioNormalized.value = !audioNormalized.value
    if (currentAudioPlayer.value) {
      currentAudioPlayer.value.normalize = audioNormalized.value
    }
  }

  return {
    showSidebar,
    toggleSidebar,
    projectName,
    projectOrigin,
    currentAudioPlayer,
    audioNormalized,
    setCurrentAudioPlayer,
    toggleAudioNormalization
  }
})
